import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  margin: auto;
  text-align: center;
  background-color: #ff6b08;
  box-shadow: 0px -2px 3px rgba(9, 30, 63, 0.1);
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  /* @media screen and (min-width: 768px) {
    left: 20%;
    width: 60%;
    border-radius: 6px;
  }
  @media screen and (min-width: 1280px) {
    left: 25%;
    width: 50%;
  } */
`;
